import * as Routes from "../Routes";
import {Address, GetOrderAddress} from "../../models/Address";
import {DataService} from "../data/data.service";
import {GenericResponse} from "../../responses/GenericResponse";
import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {Response} from "../../responses/Response";
import {timeout} from "rxjs/operators";


@Injectable({
    providedIn: 'root',
})
export class EbayService{


    constructor(
        private dataService: DataService,
        private http: HttpClient
    ) { }

    public getOAuthUrl(baseUrl: string, marketplaceId: string): Observable<Response> {
        return this.http.get<Response>(`${Routes.PARCEL_EBAY_ROUTE}/OAuth/` + baseUrl + '/' + marketplaceId + '/', this.dataService.getHttpOptions());
    }
    public getOrders(selectedAddress: GetOrderAddress, marketId: string): Observable<GenericResponse<number>>{
        return this.http.post<GenericResponse<number>>(
            `${Routes.PARCEL_EBAY_ROUTE}/orders/${marketId}/`,
            selectedAddress, this.dataService.getHttpOptions()).pipe(timeout(30000));
    }
    /*
    public getOrders(selectedAddress: Address): Observable<Response> {
        return this.http.post<Response>(`${Routes.PARCEL_EBAY_ROUTE}/getOrders`, selectedAddress, this.dataService.getHttpOptions());
    }
     */

    public registerCode(code: string, marketplaceId: string): Observable<Response> {
        return this.http.post<Response>(`${Routes.PARCEL_EBAY_ROUTE}/registerCode/${marketplaceId}/`, code, this.dataService.getHttpOptions());
    }

    public verify(marketplaceId: string): Observable<GenericResponse<boolean>> {
        return this.http.get<GenericResponse<boolean>>(`${Routes.PARCEL_EBAY_ROUTE}/verify/${marketplaceId}/`, this.dataService.getHttpOptions());
    }
}
